export const alsConfig = {
  triggers: null,
  colors: null,
  loading: false,
  retrieved: false,
};
